export const captureException = (error: unknown) => {
    if (typeof error === 'string' || error instanceof Error) {
        window.newrelic?.noticeError(error);
    }
};
